
import React from 'react';

const CaseStudiesSection = () => {
  const caseCategories = [
    {
      title: '难就业专业',
      icon: 'ri-graduation-cap-line',
      cases: [
        '土木工程转人工智能拿下腾讯ssp offer',
        '双非文科生进藤校后又成为全球第一美妆企业管培生',
        '非STEM专业被美国科技巨头录用后成功留美'
      ]
    },
    {
      title: '跨国求职',
      icon: 'ri-global-line',
      cases: [
        '一年硕士时间紧迫，依旧美港陆三地拿offer',
        '人在海外还没毕业，被国家电网录取',
        '中外合办在读，拿下亚马逊百万年包'
      ]
    },
    {
      title: '空白简历',
      icon: 'ri-file-text-line',
      cases: [
        '大三还是空白简历，3个月拿下四大可转正实习offer',
        '0实习经历不仅拿到顶尖大学商科录取，还能进入中金工作',
        '相关经历为零，apple照样给出百万offer'
      ]
    },
    {
      title: '背景学校差',
      icon: 'ri-school-line',
      cases: [
        '双非简历石沉大海，录取港大后求职季比亚迪给出70万年薪',
        '国内普校录取常青藤，毕业后进入摩根大通',
        '二本学生留学求职两手抓，拿下校史首个腾讯offer+全球前十名校offer'
      ]
    },
    {
      title: '延毕/错过求职季',
      icon: 'ri-time-line',
      cases: [
        '毕业即失业2年后，拿下央企金饭碗',
        '博士被迫延毕后，人工智能硬件领头羊英伟达抛来橄榄枝',
        '海外学子gap中，收到麦肯锡offer'
      ]
    },
    {
      title: '辞职/行业不景气',
      icon: 'ri-briefcase-line',
      cases: [
        '裸辞牛马岗位，拥抱外企新生活',
        '遭遇房地产行业崩塌后，成功投身AI创新浪潮',
        '被前司无情优化，重拾信心拿下百万年薪offer'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            逆袭案例：有短板也没问题
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            无论你面临什么困难，我们都有成功的解决方案和真实案例
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {caseCategories.map((category, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6 pb-4">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${category.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">
                      {category.title}
                    </h3>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-0">
                {category.cases.map((caseItem, caseIndex) => (
                  <div key={caseIndex} className="relative aspect-video">
                    <img 
                      src={
                        index === 0 && caseIndex === 0 
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/fc5b81ade63c1dc92f33676109860953.jpeg"
                          : index === 0 && caseIndex === 1
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/4deef199ec10e5c02e36358a626a1f9e.jpeg"
                          : index === 0 && caseIndex === 2
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/24a205ae82ab382ea1dddbe7a0c856ed.jpeg"
                          : index === 1 && caseIndex === 0
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/5eaccc474fff075dee6ddbdf45d86948.jpeg"
                          : index === 1 && caseIndex === 1
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/fb9ce904de17e4e8d6f349866a8588d5.jpeg"
                          : index === 1 && caseIndex === 2
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/19f3f0f65b1edd3107691633291cb80d.jpeg"
                          : index === 2 && caseIndex === 0
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/b5ec054ca6740e5aa88853f3ea4ecfce.jpeg"
                          : index === 2 && caseIndex === 1
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/f15a71a1cfe0b72281da4f8ab1ad4a86.jpeg"
                          : index === 2 && caseIndex === 2
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/ef36dcb203a12bd845b967942cdc5df6.jpeg"
                          : index === 3 && caseIndex === 0
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/01f8b60ca60312fd5636899cd7fa918e.jpeg"
                          : index === 3 && caseIndex === 1
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/dc223484d8dca9e74ab1f326765b2042.jpeg"
                          : index === 3 && caseIndex === 2
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/7c056215eaff90ed80df223c8d3664ba.jpeg"
                          : index === 4 && caseIndex === 0
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/cadc3be71f197be5a7e50bca4b9be7c6.jpeg"
                          : index === 4 && caseIndex === 1
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/89510f160dcc72c54518f6998b04318d.jpeg"
                          : index === 4 && caseIndex === 2
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/7657ada9ddabe95260179f0687c4a412.jpeg"
                          : index === 5 && caseIndex === 0
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/7e4aeca5f003fc1875bf2938e2bc720b.jpeg"
                          : index === 5 && caseIndex === 1
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/51a18d37de7af29ca4f2ebc3fda37b8c.jpeg"
                          : index === 5 && caseIndex === 2
                          ? "https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/027c39f39ffd3a9d0b234ddaf5a63912.jpeg"
                          : `https://public.readdy.ai/ai/img_res/b4a6e66266d15ab3211b7075434d0a6f.jpg${index}-${caseIndex}&orientation=landscape`
                      }
                      alt="学生照片"
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center p-3">
                      <p className="text-white text-sm leading-relaxed text-center font-medium">
                        {caseItem}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="p-6 pt-4">
                <button className="text-blue-600 hover:text-blue-70000 font-medium text-sm flex items-center cursor-pointer whitespace-nowrap">
                  查看更多案例
                  <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
